import { ChangeDetectionStrategy, Component, type OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-confirm-delete-user-block',
    templateUrl: './confirm-delete-user-block-modal.component.html',
    styleUrls: ['./confirm-delete-user-block-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class ConfirmDeleteUserBlockModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCloseModal(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
